/**
 * SMSWiser Catalog query keys
 * For Media Devoted | Created By Ciro Autiero
 */

export const smswiserCatalogKeys = {
  all: ['smswiser-catalog'] as const,
  countries: () => [...smswiserCatalogKeys.all, 'countries'] as const,
  countriesWithStatus: () => [...smswiserCatalogKeys.countries(), 'status'] as const,
  refresh: () => [...smswiserCatalogKeys.all, 'refresh'] as const,
  tables: () => [...smswiserCatalogKeys.all, 'tables'] as const,
  tableRows: (table: string, params: { limit: number; offset: number; countryKey?: string; q?: string }) =>
    [...smswiserCatalogKeys.all, 'table', table, params] as const,
  countryBundle: (countryKey: string) => [...smswiserCatalogKeys.all, 'country-bundle', countryKey] as const,
  leadsForFetch: (countryKeys?: string) => [...smswiserCatalogKeys.all, 'leads-for-fetch', countryKeys ?? 'all'] as const,
};
